import CooksInfo from "../../components/CooksInfo";
import React from "react";

const About = () => {
    return (
        <div>
            <CooksInfo/>
        </div>
    );
}

export default About;